import { useDispatch as useReduxDispatch } from 'react-redux';
import type { AppDispatch } from './Store';

// 型付けされた dispatch を作成
export const useDispatch = () => useReduxDispatch<AppDispatch>();